/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Editor } from '@ckeditor/ckeditor5-core/src/editor/editor';
import classNames from 'classnames';
import React, { FC } from 'react';
import { ToolButton } from '../topbar/tool-button';
import { Tool } from '../topbar/types.d';
import { checkActiveState } from '../topbar/utils';
import { balloonTools } from './balloon-tools';
import styles from './doc-balloon-toolbar.module.css';

export enum SupportedBalloonToolbarOptions {
  Link = 'link',
  Task = 'task',
  Comment = 'comment',
  HighlightText = 'highlightText',
}
interface DocBalloonToolbarProps {
  editor: Editor;
  balloonToolOptions: SupportedBalloonToolbarOptions[];
}

export const DocBalloonToolbar: FC<DocBalloonToolbarProps> = ({
  balloonToolOptions,
  editor,
}) => {
  const tools = balloonToolOptions.map((option) => balloonTools[option]);

  /* Modifying the commandName prop inline to accomodate the same key but different labels for Highlighting  */
  return (
    <div
      className={classNames(styles.toolbar)}
      onMouseDown={(e) => e.preventDefault()}
    >
      {tools.map(({ group, items }) => (
        <div className={styles.group} key={group}>
          {(items as Tool[]).map(
            ({ key, Component, data, label, haveItsOwnHandler, keyStroke }) => (
              <ToolButton
                popoverPosition="top"
                commandName={
                  label === 'toolbar.remove_highlight' ? 'removeHighlight' : key
                }
                commandValue={data}
                className={styles.button}
                classNameEnabled={styles.button_enabled}
                editor={editor}
                label={label}
                keyStroke={keyStroke}
                haveItsOwnHandler={haveItsOwnHandler}
                key={
                  label === 'toolbar.remove_highlight'
                    ? `removeHighlight-${data}`
                    : `${key}-${data}`
                }
                command={editor?.commands.get(key)}
                haveActiveState={checkActiveState(key)}
              >
                {React.createElement(Component, { editor })}
              </ToolButton>
            ),
          )}
        </div>
      ))}
    </div>
  );
};
